<div class="relative">
  <div class="overlayerContent">
    <div class="p-5 relative">
      <div class="bg-primary-500/70 absolute backdrop-blur-md inset-0"></div>
      <img src="/assets/images/patternHover.png"
           alt=""
           class="absolute inset-0  w-full h-full object-fill ">
      <div class="mt-3 intro-x flex md:flex-row flex-col items-center gap-4 w-11/12 mx-auto min-h-[340px] "
           [style]="{'--order':1, 'opacity' : 0}">
        <div class="flex flex-col items-center gap-3 text-white md:w-2/12 w-full ">
          <div class="mgQn">
            <mat-icon svgIcon="majorQuestion"></mat-icon>
          </div>
          <div class="text-lg font-semibold mt-3">
            {{ "Je, Una swali ?"|concat|translate }}
          </div>
          <div
            routerLink="/faq-tgsd/general"
            class="bg-secondary-500 transition-all duration-150 ease-linear hover:cursor-pointer hover:rounded-lg hover:bg-secondary-400 text-lg  text-primary-500 px-4 py-2 gap-2 flex items-center">
            <span>{{ "Niulize"|concat|translate }}</span>
            <mat-icon>arrow_right_alt</mat-icon>
          </div>
        </div>
        <div
          class=" md:w-4/12 w-full flex flex-col items-center justify-center gap-1 pr-5 border-r-4 h-full border-white/50"
          *ngIf="faqs$ | async as faqs"
          appSequentialAnimate>
          @for (item of faqs; track item) {
            <div
              (click)="activeKey=$index"
              class="text-white text-lg transition-all duration-150 ease-linear hover:bg-white/50 hover:cursor-pointer bg-white/30 {{activeKey==$index ?'border-l-2 border-secondary-500':''}} px-2 py-2 w-full">
              {{ item?.questionName }}
            </div>
          }
        </div>

        <div class="md:w-6/12 w-full  justify-center gap-1 transition-all duration-150 ease-linear  text-lg text-white">
          {{ getActiveDescription() }}
        </div>
      </div>
    </div>
    <div (mouseover)="exitHover.emit(null)" class="min-h-[170vh] w-full backdrop-blur-lg"></div>
  </div>
</div>
